
<!-- <div v-if="isShow"> -->
<LineChartJS v-if="isShow" :data="finalData" :options="finalOptions" />
<!-- </div> -->
